import { Flex, HStack } from "@chakra-ui/react";
import TagByResourceType from "components/Tag/TagByResourceType";
import { AdminMeetingTypeTag } from "design-system";
import { Meeting } from "features/Resources/Meeting/models";
import { MeetingTemplate } from "features/Resources/MeetingTemplate/models";
import NameField from "features/Resources/Shared/Components/Fields/NameField";
import { UseFormReturn } from "react-hook-form";

interface MeetingHeaderProps {
  form: UseFormReturn<any>;
  meeting: Meeting | MeetingTemplate;
  isDisabled?: boolean | undefined;
}

export default function MeetingHeader({ form, meeting, isDisabled = false }: MeetingHeaderProps) {
  if (!meeting) {
    return null;
  }
  return (
    <Flex w="100%" justify="space-between" align="center">
      <HStack w="75%">
        <AdminMeetingTypeTag.IconBadge meetingType={meeting.meetingType} />
        <NameField form={form} disabled={isDisabled} />
      </HStack>
      <TagByResourceType type="meeting" />
    </Flex>
  );
}
